import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
const MessageErrorIcon = ({ message, isAgent }) => {
  // sendingStatus가 FAILED인 경우에만 에러 아이콘 표시
  if (message?.sendingStatus !== "failed") {
    return null;
  }
  return (
    <div
      className={`flex items-center gap-2 ${
        isAgent ? "justify-start" : "justify-end"
      }`}
    >
      <div className="flex items-center gap-1 text-red-500 text-xs pl-2">
        <FaExclamationTriangle className="text-red-500" />
        <span className="text-red-600 font-medium">전송 실패</span>
      </div>
    </div>
  );
};
export default MessageErrorIcon; 